module.exports = __webpack_public_path__ + "img/packing.dcf46196.svg";